import { render, staticRenderFns } from "./SkyTvChannels.vue?vue&type=template&id=5c56bc04&scoped=true&"
import script from "./SkyTvChannels.vue?vue&type=script&lang=js&"
export * from "./SkyTvChannels.vue?vue&type=script&lang=js&"
import style0 from "./SkyTvChannels.vue?vue&type=style&index=0&id=5c56bc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56bc04",
  null
  
)

export default component.exports